import type { RootState, UserState } from '../types';

export function getProfileState(state: RootState): UserState['profile'] {
    return state.user.profile || null;
}

export function isProfileLoaded(state: RootState): boolean {
    return Boolean(getProfileState(state));
}

export function getProfileCompanyName(state: RootState) {
    return getProfileState(state)?.company?.name || null;
}

export function getProfileUserName(state: RootState) {
    return getProfileState(state)?.companyUsername || null;
}

export function getProfileEmail(state: RootState) {
    return getProfileState(state)?.email || null;
}

export function getProfileTelephonyId(state: RootState) {
    return getProfileState(state)?.telephonyId || '';
}

export function isProfileEmailVerified(state: RootState) {
    return Boolean(getProfileState(state)?.emailVerified);
}

export function getProfileId(state: RootState) {
    const id = getProfileState(state)?.id;
    return typeof id === 'string' || typeof id === 'number' ? id : undefined;
}
